import React from 'react';
import { ListFieldSection } from '../../../../Layout';
import { Field, RadioGroup, TextOutput } from '../../../../Core';
import { useSelector } from 'react-redux';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';

let AstmCompactionMethodSection = ({ createWorksheetSelector = undefined }) => {
  const compactionMethodDeterminedBy = useSelector(createWorksheetSelector('Preparation.CompactionMethodDeterminedBy'));
  return (
    <ListFieldSection>
      <Field
        input={<RadioGroup />}
        label="Compaction Method Determined By"
        name="Preparation.CompactionMethodDeterminedBy"
        options={[
          { label: 'Oversize Percentage', value: 'calculated' },
          { label: 'Predefined, estimated or from material specification', value: 'userdefined' },
        ]}
      />
      <Field
        input={compactionMethodDeterminedBy === 'userdefined' ? <RadioGroup /> : <TextOutput />}
        label="Compaction Method"
        name="Preparation.CompactionMethod.Id"
        options={['A', 'B', 'C'].map((e) => ({ label: e, value: e }))}
      />
    </ListFieldSection>
  );
};

AstmCompactionMethodSection = withInjectedProps(AstmCompactionMethodSection);

export { AstmCompactionMethodSection };
export default AstmCompactionMethodSection;
